import { render, staticRenderFns } from "./GoodsReturnItems.vue?vue&type=template&id=35cd10da"
import script from "./GoodsReturnItems.vue?vue&type=script&lang=js"
export * from "./GoodsReturnItems.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports